import baseUrl from './baseUrl';
import { baseUrlQRCode } from './baseUrlQRCode';
import isTokenExpired from '../helpers/isTokenExpired';

function checkToken() {
    const token = window.localStorage.getItem('token');

    if (token) {
        if (isTokenExpired(token)) {
          window.localStorage.clear();
          window.location.replace('/');

          return isTokenExpired(token);
        }
    }
}

export const capsDocsService = {
    async getAllDocs(idUsuario, capsUrl, pageNumber = 1, limit = 1000, filterBy = 'id', orderBy = 'asc') {
        if (checkToken()) return;

        const data = await fetch(`${baseUrl}/${capsUrl}/docs/${idUsuario}?page=${pageNumber}&limit=${limit}&filterBy=${filterBy}&orderBy=${orderBy}`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });

        const response = await data.json();

        return response;
    },
    async getDoc(id, capsUrl) {
        const data = await fetch(`${baseUrl}/${capsUrl}/doc/${id}`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });

        const response = await data.json();

        return response;
    },
    async create(data, capsUrl) {
        const response = await fetch(`${baseUrl}/${capsUrl}/docs`, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(data)
        });

        return response;
    },
    async update(id, values, capsUrl) {
        const data = await fetch(`${baseUrl}/${capsUrl}/doc/${id}`, {
            method: 'PUT',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(values),
        });

        const response = await data.json();

        return response;
    },
    async validate(capsUrl, hash) {
        const data = await fetch(`${baseUrlQRCode.api}/${capsUrl}/doc/validar/${hash}`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
            },
        });

        const response = await data.json();

        return response;
    }
}